/**
 * Notification CrossFrame Listeners
 *
 * Handles CrossFrame requests for notification operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetNotificationsInput } from '@amzn/coral_com-amazon-jwostoremanagementgateway/GetNotificationsInput'
import { GetNotificationsOutput } from '@amzn/coral_com-amazon-jwostoremanagementgateway/GetNotificationsOutput'
import { validateRequired } from './listenerUtils'

export async function getNotificationsListener (message: any): Promise<GetNotificationsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getNotifications(GetNotificationsInput.clone(params)).toPromise()
}
